import { get, isEmpty } from "lodash";
export function getRealmOwnerData(authData: any) {
  let allRealmData = get(authData, "realms", {});
  if (isEmpty(allRealmData)) {
    allRealmData = get(authData, "userRealmsDetails.realms", {});
  }
  return { realms: allRealmData || [], realmOwnerData: allRealmData[0] || {} };
}

export function getTraderAuthData(data) {
  const auth = !isEmpty(data) && data !== "undefined" ? JSON.parse(data) : JSON.parse(localStorage["AUTH_CONFIG"]);
  // let realmData = auth.realms[0];
  let realmData = getRealmOwnerData(auth);
  return auth?.userId
    ? {
        existingUser: "true",
        realms: realmData.realms,
        token_type: "Bearer",
        userId: auth.userId,
        expires_in: auth.expires_in,
        token: auth.token || auth.access_token,
        systemUserId: auth.userId, // same as userId
        realmIdentifier: realmData.realmOwnerData.realmIdentifier,
      }
    : {};
}

export function getTraderRealmData(data) {
  const auth = !isEmpty(data) && data !== "undefined" ? JSON.parse(data) : JSON.parse(localStorage["AUTH_CONFIG"]);
  return getRealmOwnerData(auth).realmOwnerData || {};
}
